<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<!-- Using same layout vis-à-vis tooltips, but checkbox may benefit from custom approach -->
@if (this.Mode === 'design') {
  <div class="flex-row-top-left">
    <div>
      <!-- If there are instructions, display label first, then instructions then field -->
      @if (this.HasInstructions) {
        @if (this.DisplayName) {
          <div class="design-mode-field-label">{{this.DisplayName}}</div>
        }
        <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
      }
      <mat-checkbox [(ngModel)]="this.DefaultCheckboxValue"
        (ngModelChange)="this.handleOnModelChange()"
        disabled
        class="set-left-align">
        @if (!this.HasInstructions) {
          <span>{{this.DisplayName}}</span>
        }
      </mat-checkbox>
      <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
  </div>
}

@if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
  <div class="flex-row-top-left">
    <div>
      <!-- If there are instructions, display label first, then instructions then field -->
      @if (this.HasInstructions) {
        @if (this.DisplayName) {
          <div class="field-label">{{this.DisplayName}}</div>
        }
        <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
      }
      @if ((this.ControlType === 'Reactive Forms') && (this.FormControl !== null)) {
        <mat-checkbox [formControl]="this.FormControl"
          id="{{this.MatInputId}}"
          #matCheckbox
          (blur)="this.handleOnBlur()"
          (focus)="this.handleOnFocus($event)"
          class="set-left-align">
          @if (!this.HasInstructions) {
            <span>{{this.DisplayName}}</span>
          }
        </mat-checkbox>
      }
    </div>
    <div style="margin-top:-25px;">
      <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
    </div>
  </div>
}
